var $7ea012e91a5ad3ee$exports = {};
$7ea012e91a5ad3ee$exports = {
    "alpha": `Alfa`,
    "blue": `Sinine`,
    "brightness": `Heledus`,
    "green": `Roheline`,
    "hue": `V\xe4rv`,
    "lightness": `Valgus`,
    "red": `Punane`,
    "saturation": `K\xfcllastus`
};


export {$7ea012e91a5ad3ee$exports as default};
//# sourceMappingURL=et-EE.module.js.map
